import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-llamadas-bitacora',
  templateUrl: './llamadas-bitacora.component.html',
  styleUrls: ['./llamadas-bitacora.component.scss']
})
export class LlamadasBitacoraComponent implements OnInit, AfterViewInit, OnDestroy {

  // variables dataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor(@Inject(MAT_DIALOG_DATA) public _data, private _cartera: CarteraService) {
    this.dtTrigger.next();

    this.dtOptions = {
      scrollY: '383px',
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      order: [ 1, 'desc'],
      columns: [
        {
          title: 'N°Llamada',
          data: 'ID_llamadas'
        },
        {
          title: 'Fecha Llamada',
          data: 'Fecha_llamada'
        },
        {
          title: 'Hora',
          data: 'Hora_llamada'
        },
        {
          title: 'Actividad',
          data: 'Actividad'
        },
        {
          title: 'Observación Llamada',
          data: 'ObservacionLlamada'
        },
        {
          title: 'Encargado Llamada',
          data: 'encargado'
        },
        {
          title: 'Responsable Llamada',
          data: 'responsable'
        },
        {
          title: 'N°Cobro',
          data: 'cobro'
        },
        {
          title: 'Factura #1',
          data: 'factura_1'
        },
        {
          title: 'Factura #2',
          data: 'factura_2'
        },
        {
          title: 'Factura #3',
          data: 'factura_3'
        },
        {
          title: 'Fecha Actividad',
          data: 'Fecha_actividad'
        }
      ],
      responsive: true
    }
    
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // ----------------------------------------------------------------------------------------------------- 

  /**
   * On Init
   */
  ngOnInit() {
    if(this._data.llamadas === undefined){
      this._cartera.VerLlamadasBitacora(this._data.factura ? this._data.factura : '0', this._data.id_grupo)
                    .subscribe((data: any) => {
                      this.tableOpt = data;
                      this.renderer();
                    });
    }else{
      this.tableOpt = this._data.llamadas;
      this.renderer();
    }
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
